import * as React from 'react';
import { useReviewsContext } from '@grandvisionhq/reviews';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { UserReviews } from '../../Reviews/UserReviews.js';
import { ProductDetailReviews } from './ProductDetailReviews.js';

const ProductDetailReviewsDrawerContainer = ()=>{
    const { isPdpDrawerLayoutEnabled  } = useFeatureToggles();
    const { reviewCount  } = useReviewsContext();
    const { getLabel  } = useIntl();
    const title = getLabel('reviews.drawer.button.title');
    if (!isPdpDrawerLayoutEnabled || !reviewCount) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("section", {
        className: "product-detail-reviews",
        "aria-label": title,
        "data-t": "product-detail-reviews"
    }, /*#__PURE__*/ React.createElement(ProductDetailReviews, {
        title: title
    }, /*#__PURE__*/ React.createElement(UserReviews, {
        isSingleColumn: true
    })));
};

export { ProductDetailReviewsDrawerContainer };
//# sourceMappingURL=ProductDetailReviewsDrawerContainer.js.map
